import patterns from '../../../universal/spinneybeck/patterns'
import blocks from '../../../universal/spinneybeck/blocks'
import generateGrid from './generate-pattern'
import generateSp402Grid from '../filzfelt/generate-pattern'
import getSp402Variant from './get-sp402-variant'

export default id => {
  const {
    name,
    preview: {
      width = 144,
      height = 96
    } = {}
  } = patterns[id]

  return /402/.test(name)
    ? sp402(id, width, height)
    : dnd(id, width, height)
}

function dnd (id, width, height) {
  const b = generateGrid(id, width, height)
  let preview = `<svg viewBox="0 0 ${width} ${height}">`
  for (const { id, x, y, r } of Object.values(b)) {
    const d = blocks[id].d
    preview += `<g transform="translate(${x} ${y})">`
    preview += `<polygon points="0,0 16,0 16,16 0,16" fill="transparent" />`
    if (d) preview += `<path d="${d}" transform="rotate(${r || 0} 8 8)" />`
    preview += `</g>`
  }
  preview += `<rect width="${width}" height="${height}" />`
  preview += `</svg>`
  return {
    id,
    preview,
    name: patterns[id].name
  }
}

function sp402 (id, width, height) {
  let preview = `<svg viewBox="0 0 ${width} ${height}" fill="transparent">`

  const data = generateSp402Grid(id, width, height)

  for (const [key, block] of Object.entries(data)) {
    const variant = getSp402Variant(data, key)
    if (variant) {
      preview += `<path transform="translate(${block.x}, ${block.y})" d="${blocks[block.id].variants[variant]}" />`
    }
  }

  preview += `<rect width="${width}" height="${height}" />`
  preview += '</svg>'

  return {
    id,
    preview,
    name: patterns[id].name
  }
}



// WEBPACK FOOTER //
// ./src/client/lib/spinneybeck/generate-preview.js